require('./media/js/csrf.ts');
require('./media/js/mp-globals.ts');
